/* パスワード変更（職員、お客様共通） */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Text from '../../molecules/Text';
import CenterButton from '../../atoms/CenterButton';
import axios from '../../axios';
import { Row, Col } from 'react-bootstrap';
import { handleBrowserBack } from '../../BrowserBack';
import 'url-search-params-polyfill';
import LoadingModal from '../../molecules/LoadingModal';
import { jumpUrl } from './../../Common';

const PasswordChange: React.FC = () => {
  // メールアドレス
  const [email, setEmail] = useState('');
  // パスワード
  const [password, setPassword] = useState('');
  // パスワード(確認)
  const [password_confirmation, setPasswordConfirmation] = useState('');
  const [password_change_message, setPasswordChangeResult] = useState('');

  const [status_code, setStatusCode] = useState(0);
  // API通信中フラグ
  const [is_connecting, setIsConnecting] = useState(false);

  //ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);

  // エラーメッセージ
  const [error_email, setErrorEmail] = useState('');
  const [error_password, setErrorPassword] = useState('');
  const [error_password_confirm, setErrorPasswordConfirm] = useState('');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);
  // モーダルクローズ & ログイン画面に遷移
  const redirectToLogin = () => {
    location.replace(`${process.env.MIX_MOCK_URL}/mypage/login`);
  };

  // 各入力項目への入力
  // メールアドレスの入力
  const handleChangeEmail = (value: string) => {
    setEmail(value);
  };
  // パスワードの入力
  const handleChangePassword = (value: string) => {
    setPassword(value);
  };
  // パスワード（確認用）の入力
  const handleChangePasswordConfirmation = (value: string) => {
    setPasswordConfirmation(value);
  };

  // パスワード変更ボタンのクリックイベントを定義
  const handleClickPasswordChange = () => {
    //メールからの画面遷移の場合
    const search_params = new URLSearchParams(document.location.search.substring(1));

    // ログイン情報をStateへセット
    // 結果表示ボックスに適用するCSSクラス名
    const password_info = {
      password: password,
      password_confirmation: password_confirmation,
      email: email,
      token: search_params.get('token'),
    };

    // エラーメッセージをリセットする
    setErrorEmail('');
    setErrorPassword('');
    setErrorPasswordConfirm('');
    setPasswordChangeResult('');

    const passwordChange = async () => {
      try {
        if (is_connecting) {
          return;
        }
        //ローディング画面表示
        setIsLoading(true);
        setIsConnecting(true);

        const url = `${location.origin}${process.env.MIX_MOCK_URL}/password/change`;
        const response = await axios.post(url, password_info);
        setStatusCode(response.status);

        // ダイアログ表示
        redirectToLogin();
      } catch (error) {
        // 失敗
        jumpUrl(error.response.data.url);

        // エラーメッセージの設定
        if (typeof error.response.data.message === 'object') {
          // オブジェクトが返却されてきた場合
          if (typeof error.response.data.message.email !== 'undefined') {
            setErrorEmail(error.response.data.message.email);
          }
          if (typeof error.response.data.message.password !== 'undefined') {
            setErrorPassword(error.response.data.message.password);
          }
          if (typeof error.response.data.message.password_confirmation !== 'undefined') {
            setErrorPasswordConfirm(error.response.data.message.password_confirmation);
          }
        } else {
          // stringが返却されてきた場合
          setPasswordChangeResult(error.response.data.message);
        }

        setStatusCode(error.response.status);
        setIsConnecting(false);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    // パスワード変更処理
    passwordChange();
  };

  return (
    <>
      <Block
        label="パスワード変更"
        content={
          <>
            <div className="mt-3">
              <Text
                id="email"
                label="メールアドレス"
                type="text"
                value={email}
                placeholder="example@example.com"
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeEmail(event.target.value)
                }
                disabled={false}
                maxlength={50}
                message={error_email}
                display_border={true}
              />
              <Text
                id="password"
                label="パスワード"
                type="password"
                value={password}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangePassword(event.target.value)
                }
                disabled={false}
                maxlength={256}
                message={error_password}
                display_border={true}
              />
              <Text
                id="password-confirm"
                label="パスワード(確認用)"
                type="password"
                value={password_confirmation}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangePasswordConfirmation(event.target.value)
                }
                disabled={false}
                maxlength={256}
                message={error_password_confirm}
                display_border={true}
              />
            </div>
            <Row className="d-flex align-items-center justify-content-center error-message-spacing">
              <Col></Col>
              {password_change_message !== undefined &&
                // パスワード変更失敗メッセージあり
                status_code !== 201 && (
                  // 失敗
                  <Col md={8} className="alert-danger alert-danger-custom">
                    {password_change_message}
                  </Col>
                )}
            </Row>
          </>
        }
      />
      <CenterButton
        label="パスワードを変更する"
        handleClick={handleClickPasswordChange}
        btn_class="mb-5 arrow-right"
      />

      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};
if (document.getElementById('common-password-change')) {
  ReactDOM.render(<PasswordChange />, document.getElementById('common-password-change'));
}
